import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalConfig } from '@core/models/modal-config.model';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-signup-success-modal',
  templateUrl: './signup-success-modal.component.html',
  styleUrls: ['./signup-success-modal.component.scss'],
})
export class SignupSuccessModalComponent {
  buttonText: string = $localize`CLOSE`;

  @Input() txtMessage: string;

  modalConfig: ModalConfig = {
    hideCloseButton: true,
    hideDismissButton: true,
    hideHeader: true,
    onDismiss: this.modalDone.bind(this),
    ngbModalOptions: {
      size: 'md',
      modalDialogClass: 'successModal',
    },
  };

  @Output() closed = new EventEmitter<void>();
  @ViewChild('successModal') private successModal: ModalComponent;

  constructor() {}

  open(): void {
    if (!this.successModal) {
      return;
    }
    this.successModal.open();
  }

  onClose(): void {
    this.successModal.close();
  }

  private modalDone() {
    return;
  }
}
